import * as ActionTypes from '~/actions/ActionTypes'
import { activateProject } from '~/actions/projectData/activateProject'
import { newProjectName } from '~/constant'
import * as API from '~/ServerAPI'
import { hideBlankProjectFromList } from './hideBlankProjectFromList'
import { fetchNextProjectName } from './fetchNextProjectName'

export const createProject = (
  data,
  name = newProjectName,
  thumbnail,
  createTime = Date.now(),
  options
) => async dispatch => {
  let id = null
  try {
    const {
      isInitialRenaming = false,
      updateProjectFileRefCount = false,
    } = options ?? {}

    const modifTime = createTime
    const nextProjectName = await dispatch(fetchNextProjectName(name))
    let projectParams = { name: nextProjectName, data, thumbnail, createTime, modifTime }
    id = (await API.createProject(projectParams)).id

    // updateProjectFileRefCount: for saveAs existing project and duplicate project
    if (updateProjectFileRefCount) {
      const { data: { references } } = await API.updateProjectFileRefCount(id)
      const updatedFileIds = references?.map(ref => ref.fileId)
      const fileIds = Array.from(
        new Set([ ...(projectParams.data?.fileIds ?? []), ...(updatedFileIds ?? []) ])
      )

      projectParams = {
        ...projectParams,
        data: JSON.stringify({ ...JSON.parse(projectParams.data), fileIds }),
      }
      dispatch({
        type: ActionTypes.UPDATE_MEDIA_FILE_REF_COUNT,
        payload: {
          references,
        },
      })
    }

    let projectPayload = { project: { id, ...projectParams } }

    if (isInitialRenaming) {
      projectPayload = { ...projectPayload, isInitialRenaming }
    }

    await dispatch({
      type: ActionTypes.PROJECTS_CREATE,
      payload: projectPayload,
    })
    const activeProject = JSON.parse(data)
    await dispatch(activateProject({ id, name: nextProjectName, activeProject }))
    await dispatch(hideBlankProjectFromList())
  } catch (e) {
    console.error('Failed to create new project')
  }
  return id
}
